module.exports = {"210214001":"丰荣街道","210214002":"铁西街道","210214003":"太平街道","210214004":"南山街道","210214005":"皮口街道","210214006":"城子坦街道","210214007":"大刘家街道","210214008":"杨树房街道","210214009":"大谭街道","210214010":"唐家房街道","210214011":"莲山街道","210214106":"双塔镇","210214107":"安波镇","210214108":"四平镇","210214109":"沙包镇","210214117":"星台镇","210214206":"墨盘乡","210214208":"同益乡","210214209":"乐甲满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210214.json
// module id = 472
// module chunks = 0